import React from 'react'
import { T } from '@transifex/react'
import { Button } from '@lightspeed/design-system-react'
import { ApiRetailerPaymentType } from '@vend/types'
import { SaleStatus } from '../../../models/sale.constants'
import { SystemPaymentType } from './hooks/useFetchPaymentTypes'
import { useCustomerPaymentOptions } from './hooks/useCustomerPaymentOptions'
import { usePaymentDisabledState } from './hooks/usePaymentDisabledState'
import { LSPayPMOF } from './LSPayPaymentMethodOnFile/LSPayPMOF'

type LaybyOnAccountSale = (
  status: SaleStatus.LAYBY_SALE | SaleStatus.ACCOUNT_SALE
) => Promise<void>
export type CustomerPaymentOptionsProps = {
  systemPaymentTypes: SystemPaymentType
  pay: (paymentType: ApiRetailerPaymentType) => void
  laybyOnAccountSale: LaybyOnAccountSale
  amountTendered: string
  hasPaymentAmountError: boolean
}

/**
 * Customer Payment Options component for payment panel
 */
export const CustomerPaymentOptions = (props: CustomerPaymentOptionsProps) => {
  const {
    systemPaymentTypes,
    pay,
    laybyOnAccountSale,
    amountTendered,
    hasPaymentAmountError,
  } = props
  const {
    paymentOptions,
    isStoreCreditAndLoyaltyPaymentUnable,
  } = useCustomerPaymentOptions({
    systemPaymentTypes,
    pay,
    laybyOnAccountSale,
  })
  const { getDisabledState } = usePaymentDisabledState(
    amountTendered,
    hasPaymentAmountError
  )
  return (
    <>
      <LSPayPMOF
        paymentType={systemPaymentTypes.lspayPaymentType ?? undefined}
        pay={pay}
        disabled={getDisabledState('pmof')}
      />
      <div
        id="confirmed-payment-options-group"
        className="payment-type-button-group vd-btn-group vd-mt4"
      >
        {isStoreCreditAndLoyaltyPaymentUnable && (
          <div className="payment-offline-message vd-ml1 vd-text--sub">
            <span className="vd-i vd-i-wifi-out vd-mr1">
              <T
                _str="You’re currently offline and unable to process this sale with some payment methods."
                _context="Text message for not able to process some payment methods"
              ></T>
            </span>
          </div>
        )}
        {paymentOptions.map(({ id, action, label }) => {
          const isDisabled = getDisabledState(id)

          return (
            <Button
              jumbo
              key={id}
              className="btn--payment-type"
              disabled={isDisabled}
              onClick={action}
              variant="supplementary"
              data-track={`payment-option-${label}`}
            >
              {label}
            </Button>
          )
        })}
      </div>
    </>
  )
}
